import { useRef, useState } from 'react';
import Box from '@mui/material/Box';
import UserInfoBox from './UserInfoBox';
import SelectAccountMenu from './SelectAccountMenu';

interface UserMenuProps {
  open: boolean;
}

const UserMenu = ({ open } : UserMenuProps) => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [expanded, setExpanded] = useState(false);

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  const closeMenu = () => {
    setExpanded(false);
  };

  return (
    <Box id="sidebar-user-menu" ref={anchorRef}>
      {/* User Info box */}
      <UserInfoBox
        open={open}
        expanded={expanded}
        handleExpand={handleExpand}
      />

      {/* User select account menu */}
      <SelectAccountMenu
        open={open}
        expanded={expanded}
        anchorEl={anchorRef.current}
        closeMenu={closeMenu}
      />
    </Box>
  );
};

export default UserMenu;
